'use strict';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, size, sumBy, get} from 'lodash'
import { getPaymentsNEW, linkPaymentsTo5000, unLinkPaymentsTo5000, getIncomeInfo, getPaymentSmsInfo } from '../../../../../jsx/actions/paymentAction';
import RepayDashboard from './Repayment/RepayDashboard.jsx';
import CardPage from '../../commonModules/layouts/CardPage.jsx';
import { Box, TableBody, TableRow, TableCell, TableHead, Card, AppBar, Tabs, Tab, IconButton, Checkbox, Button, TableSortLabel, List, ListItem, ListItemText } from '@material-ui/core';
import { TableLayout } from './Stock/containers/Layout.jsx';
import { IndeterminateCheckBoxOutlined ,CloudDownloadRounded, Add, AddRounded} from '@material-ui/icons';
import Spin from '../../commonModules/interface/Spin';
import { amber, blue, red, yellow } from '@material-ui/core/colors';
import TableFooterPagination from '../../commonModules/interface/TableFooterPagination.jsx';
import FilterList from '../AdminDashboard/Layouts/FilterList.jsx';
import { firstDayOfYear } from '../../commonModules/utils/statsFunctions.jsx';
import LinkPaymentPopUp from './Repayment/LinkPaymentPopUp.jsx';
import PaymentSingle from './Repayment/PaymentSingle.jsx';
import DeleteDialog from '../../commonModules/interface/DeleteDialog';
import Dialog from '../../commonModules/interface/Dialog';
import { incomeLinks, matched, remaining, isCancelled, canLink, matchesLinkFilter, amountError, roundAmount, paymentMatchingState } from '../../../../../jsx/utils/paymentIncomeLinks';
import { MatchingChip } from '../../commonModules/MatchingStatus';
import { MATCHING_FULL } from '../../../../../jsx/utils/factId5000';
import { toast } from 'react-toastify';
import Spinner from 'react-spinner-material';

// Un compteur SparkMeter ne recoit ni duree ni code d activation : la plateforme pilote
// le compteur par le SOLDE de son wallet. Ce qu un paiement produit, c est donc un
// CREDIT -- et c est cela qu il faut montrer a la place de la duree, qui vaut 0 pour ces
// paiements et n a aucun sens.
//
// Le fournisseur est lu sur le paiement lui-meme (champ `supplier`, fige au moment du
// stockage) : il n est pas deductible autrement, le detail du flux vivant dans un
// document separe. Absent sur les paiements anterieurs a son introduction, d ou le test
// d egalite stricte plutot qu une negation.
const SPARKMETER_SUPPLIER = 'sparkmeter';

const estPaiementSparkMeter = (payment) => !!payment && payment.supplier === SPARKMETER_SUPPLIER;

// Les devises stockees cote domainModel ne sont PAS toutes des codes ISO 4217 : les
// constantes valent "FCFA", "Euro", "Ariary" (paymentManagement.go). Or
// Intl.NumberFormat n accepte que l ISO -- passer "FCFA" leve une RangeError.
//
// Sans cette table, le repli du try/catch rendrait "5000 FCFA" au lieu de
// "5 000 F CFA" sur tout le parc Benin / Burkina / Madagascar : une regression
// d affichage generalisee pour faire fonctionner le seul cas RDC.
const DEVISES_ISO = { FCFA: 'XOF', Euro: 'EUR', Ariary: 'MGA' };

const versISO = (devise) => DEVISES_ISO[devise] || devise || 'XOF';

// Formate un montant dans SA devise. Le code precedent forcait XOF, ce qui affichait en
// FCFA des paiements libelles en USD -- soit tout le parc SparkMeter (RDC).
const formatMontantPaiement = (montant, devise) => {
	try {
		return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: versISO(devise) }).format(montant || 0);
	} catch (e) {
		// Devise vraiment inconnue : le montant brut vaut mieux qu une exception qui
		// casserait la ligne entiere.
		return `${montant || 0} ${devise || ''}`.trim();
	}
};

// Colonne « Pointage » : la même pastille que la liste des ventes. L'infobulle détaille les
// recettes 5000 rattachées, ce qu'une opération de stock n'a pas à montrer mais qui fait
// tout l'intérêt d'un paiement réparti.
const PaymentMatchingStatus = ({ payment }) => {
	const links = incomeLinks(payment);
	return (
		<MatchingChip
			state={paymentMatchingState(payment)}
			remainingLabel={formatMontantPaiement(remaining(payment), payment.currency)}
			totalLabel={formatMontantPaiement(payment.money, payment.currency)}
			fullTitle="Intégralement rapproché avec la comptabilité 5000"
			detail={links.length > 0 &&
				links.map(link =>
					<span key={link.income_id} style={{ display: 'block' }}>
						{`Recette ${link.income_id} : ${formatMontantPaiement(link.amount, payment.currency)}`}
					</span>
				)
			}
		/>
	);
};

// Ce qu un paiement a produit : un credit pour SparkMeter, une duree ailleurs.
const effetDuPaiement = (payment) =>
	estPaiementSparkMeter(payment)
		? `+ ${formatMontantPaiement(payment.money, payment.currency)} de crédit`
		: payment.day;

// Une cellule commencant par = + - @ est analysee comme une FORMULE par Excel et
// LibreOffice : « + 10,00 $US de credit » s affiche #NAME?. L apostrophe est la
// convention du tableur pour forcer le texte. Les guillemets, eux, protegent seulement
// les separateurs -- pas l interpretation.
const neutraliserFormuleCSV = (valeur) => {
	const texte = `${valeur === undefined || valeur === null ? '' : valeur}`;
	return /^[=+\-@]/.test(texte) ? `'${texte}` : texte;
};


class PaymentList extends Component{
	state = {
		paymentList: [],
		paymentListAll: [],
		sortDSC: false,

		view: "Liste",
		pageOfItems:[],
		currentPage:0,
		rowsPerPage:20,
		checkedPayments: [],
		// Montant à pointer par paiement coché (paymentID -> saisie), défaut = reste à pointer.
		linkAmounts: {},
		totalPay: 0,
		incomeID: "",
		openLink: false,
		openUnLink: false,
		unlink: {},
		// Recette à dépointer : choisie dans la liste quand le paiement en a plusieurs.
		unlinkIncomeID: "",
		openSingle: false,
		selected: {},

		searchMethod: {label:"", value:""},
		searchClient: {label:"", value:""},
		matched: {label:"", value:""},
		searchFacture: "",
		start_date: firstDayOfYear,
        end_date: new Date(),
	}

	componentWillMount = async () => {
		console.log("PaymentList  componentWillMount ")
		if(!this.props.PAYMENT_STATE.fetching && !this.props.PAYMENT_STATE.fetched){
			await this.props.getPaymentsNEW(this.state.start_date,this.state.end_date,[""])
		}
		// this.filterList()
	}
	
	onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
		// update state with new page of items
		this.setState({ pageOfItems, currentPage, rowsPerPage });
	}
	orderByDatePaiement = (list) => {
		console.log("IN SORT DATE");
		
		if (!this.state.sortDSC) {
			list.sort((a, b) => {
				a = new Date(a.timePayment);
				b = new Date(b.timePayment);
				if (a > b) {
					return -1;
				}
				if (a < b) {
					return 1;
				}
				return 0;
			});
		} else {
			list.sort((a, b) => {
				a = new Date(a.timePayment);
				b = new Date(b.timePayment);
				if (a < b) {
					return -1;
				}
				if (a > b) {
					return 1;
				}
				return 0;
			});
		}
		// this.setState({
		// 	sortDSC: sortingState
		// });
		return list
	}

	filterList = () => {
		const { PAYMENTS } = this.props;
		const { searchFacture, searchClient, searchMethod, matched } = this.state;
		
		let filteredList = this.filterDate(PAYMENTS)
		if(!isEmpty(searchFacture)){
			filteredList = filteredList.filter(item => item.transactionId.indexOf(searchFacture.toLocaleLowerCase()) > -1)
		}
		// Un paiement partiellement pointé apparaît sous les deux filtres.
		if( matched.value !== "" ) {
            filteredList = filteredList.filter( item => matchesLinkFilter(item, matched.value))
        }
		if( !isEmpty(searchClient.value)) {
            filteredList = filteredList.filter( item => item.boxId === searchClient.value)
        }
        if( Array.isArray(searchClient) && !isEmpty(searchClient) ) {
            let itemList = searchClient.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.boxId))
        }
		if( !isEmpty(searchMethod.value)) {
            filteredList = filteredList.filter( item => item.methodPayment === searchMethod.value)
        }
        if( Array.isArray(searchMethod) && !isEmpty(searchMethod) ) {
            let itemList = searchMethod.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.methodPayment))
        }

		filteredList = this.orderByDatePaiement(filteredList)
		
		return filteredList
	}
	filterDate = (list, from = this.state.start_date, to = this.state.end_date) => {
		console.log('====================================');
		console.log({list, from, to});
		console.log('====================================');
		if(!to){
			to = Date.now()
		}
		from = new Date(from).setHours(0,0,0,0)
		to = new Date(to).setHours(23,59,59,0)
		console.log('NEW DATE',{list, from, to});

		let filteredList = Object.values(list).filter( pay => 
			new Date(pay.timePayment) >= from 
			&& new Date(pay.timePayment) <= to
		)

		return filteredList
	}
	
	handleSelect = (option, name) => {
        if(option){
            this.setState({                
                [name]: option,
                currentPage: 0,
                // checkedItems :[]
            })
        } else {
            this.setState({
                [name]: {label: "", value: ""},
                currentPage: 0,
                // checkedItems :[]
            })

        }
    }
	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value,
			currentPage: 0,
			currentPageProd: 0,
		})
	}
    handleChangeDate = async (date, name) => {

		this.setState({
			[name]: date
		})
		await this.props.getPaymentsNEW(this.state.start_date,this.state.end_date,[""])
	}
	createPaymentList = () => {
		let { currentPage, rowsPerPage, checkedPayments } = this.state
		const isSelected = name => checkedPayments.indexOf(name) !== -1;
		// Même règle que la liste des ventes (matchingRowColor) : seul un paiement soldé est
		// surligné ; un paiement partiel garde un reste, que la colonne « Pointage » signale.
		const BCKG = payment => paymentMatchingState(payment) === MATCHING_FULL ? amber[50] : 'initial';
		let paymentList = this.filterList()
		console.log("createPaymentList len ",paymentList.length)

		// let BCKG = 'initial'
		// if payment.income_id !== "" {
		// 	BCKG = amber[100]
		// } 

		if( !isEmpty(paymentList) ){
			return {
				list: paymentList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( (payment, index) => 
					<TableRow 
						key={payment.timePayment} 
						hover
						style={{
							background: isCancelled(payment) ? red[100] : BCKG(payment)
						}}
					>
						<TableCell 
							padding="checkbox"
						>
							{canLink(payment) &&
								<Checkbox
									onClick={event => this.handleClick(event, payment.paymentID)}
									// disabled={!!payment.income_id}
									checked={isSelected(payment.paymentID)}
									inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
								/>
							}
							{incomeLinks(payment).length > 0 &&
							<Box p={1}>
								<IndeterminateCheckBoxOutlined
									onClick={() => this.handleOpenUnLink(payment)}
									style={{color: red[100]}}
									// indeterminate
									// inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
								/>
							</Box>
							}
						</TableCell>
						<TableCell>{new Date(payment.timePayment).toLocaleString('fr-FR')}</TableCell>
						<TableCell>{payment.transactionId && payment.transactionId.substring(0, 9)}</TableCell>
						<TableCell>{formatMontantPaiement(payment.money, payment.currency)}</TableCell>
						<TableCell>{formatMontantPaiement(roundAmount(matched(payment)), payment.currency)}</TableCell>
						<TableCell><PaymentMatchingStatus payment={payment} /></TableCell>
						<TableCell>{payment.boxId}</TableCell>
						<TableCell>{payment.userName}</TableCell>
						<TableCell>{payment.methodPayment}</TableCell>
						<TableCell>{effetDuPaiement(payment)}</TableCell>
						<TableCell>{payment.codeId}</TableCell>
						<TableCell>
							<IconButton onClick={() => this.handleSinglePayment(payment)}>
								<AddRounded />
							</IconButton>
						</TableCell>
					</TableRow>
				),
				size: size(paymentList),
				listAll: paymentList.map(pay => pay.paymentID),
				listItems: paymentList
			}
		}
		return {list: [], size: 0, listAll: []}
	}

	handleSinglePayment = (payment) => {

		this.setState({ 
			selected: payment,
			openSingle: true
		})
	}
	handleClick = (event, payID) => {
		const { PAYMENTS } = this.props;
        const { checkedPayments } = this.state;
        const selectedIndex = checkedPayments.indexOf(payID);
        let newSelected = [];
    
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedPayments, payID);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedPayments.slice(1));
        } else if (selectedIndex === checkedPayments.length - 1) {
            newSelected = newSelected.concat(checkedPayments.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedPayments.slice(0, selectedIndex),
                checkedPayments.slice(selectedIndex + 1),
            );
        }
    
		const linkAmounts = this.defaultAmounts(newSelected)
        this.setState({
            checkedPayments : newSelected,
			linkAmounts,
			totalPay: this.calcTotal(newSelected, linkAmounts)
        });
    };
	handleSelectAllClick = (event, list) => {
		const { PAYMENTS } = this.props;
        if (event && event.target.checked) {
            // let filteredList = this.filterList()
            // Tout ce qui reste à pointer, y compris les paiements partiellement pointés.
            let newList = list.filter( payID => canLink(PAYMENTS[payID]))
			const linkAmounts = this.defaultAmounts(newList)
			this.setState({
				checkedPayments : newList,
				linkAmounts,
				totalPay: this.calcTotal(newList, linkAmounts)
			});
          return;
        }
        this.setState({
            checkedPayments : [],
			linkAmounts: {},
			totalPay: 0,
			incomeID: "",
			openLink: false
        });
        
    };
	arrayEqual = ( arr1, arr2) => {
		const arr2Sorted = arr2.slice().sort();
		return arr1.length === arr2.length && 
			arr1.slice().sort().every((value, index) =>  value === arr2Sorted[index])
	}
	rmPayment = (payID) => {
		let newList = [].concat(this.state.checkedPayments)
		newList = newList.filter(id => id !== payID)
		const linkAmounts = this.defaultAmounts(newList)
		this.setState({
            checkedPayments : newList,
			linkAmounts,
			totalPay: this.calcTotal(newList, linkAmounts)
        });
	}
	// Montants à pointer des paiements cochés : la saisie déjà faite est conservée, les nouveaux
	// paiements prennent leur reste à pointer.
	defaultAmounts = (list) => {
		const { PAYMENTS } = this.props;
		const { linkAmounts } = this.state;
		const amounts = {}
		list.forEach(payID => {
			amounts[payID] = Object.prototype.hasOwnProperty.call(linkAmounts, payID)
				? linkAmounts[payID]
				: remaining(PAYMENTS[payID])
		})
		return amounts
	}
	handleChangeAmount = (payID, value) => {
		const linkAmounts = { ...this.state.linkAmounts, [payID]: value }
		this.setState({
			linkAmounts,
			totalPay: this.calcTotal(this.state.checkedPayments, linkAmounts)
		})
	}
	// Premier message d'erreur de saisie parmi les paiements cochés, "" si tout est valide.
	linkAmountsError = () => {
		const { PAYMENTS } = this.props;
		const { checkedPayments, linkAmounts } = this.state;
		for (const payID of checkedPayments) {
			const error = amountError(linkAmounts[payID], remaining(PAYMENTS[payID]))
			if (error) {
				return `${PAYMENTS[payID].userName || payID} : ${error}`
			}
		}
		return ""
	}
	handleSubmitLink = async () => {
		const { PAYMENTS } = this.props;

		const { checkedPayments, linkAmounts } = this.state;
		const amountsError = this.linkAmountsError()
		if (amountsError) {
			toast.error(amountsError)
			return
		}

		let paymentsID = Object.values(checkedPayments).map(pay => PAYMENTS[pay].paymentID )
		// Montant à pointer par paiement, indexé par l'identifiant métier attendu par domainModel.
		const amounts = {}
		checkedPayments.forEach(pay => {
			amounts[PAYMENTS[pay].paymentID] = roundAmount(linkAmounts[pay])
		})

		let data = {
			income_id : this.state.incomeID,
			payments: checkedPayments,
			paymentsID,
			amounts,
			total: this.calcTotal(checkedPayments, linkAmounts)
		}
		const issue = await this.props.linkPaymentsTo5000(data)
		// L'action rend son résultat. Le test portait sur le store, dont la valeur est
		// capturée au rendu et n'est donc pas rafraîchie par l'await : un échec
		// s'affichait comme un succès.
		if (issue && issue.ok === false) {
			toast.error(issue.error || "L'opération n'a pas abouti.")
			return
		}
		toast.info("Opération enregistrée avec succès")
		this.handleSelectAllClick()                        	
	}
	handleOpenUnLink = (payment) => {
		const links = incomeLinks(payment)
		// Un seul lien : confirmation directe. Plusieurs : la recette est choisie d'abord.
		this.setState({
			unlink: payment,
			unlinkIncomeID: links.length === 1 ? links[0].income_id : "",
			openUnLink: true
		})
	}
	closeUnLink = () => this.setState({ openUnLink: false, unlink: {}, unlinkIncomeID: "" })
	handleSubmitUnLink = async () => {
		// Le store PAYMENTS est indexé par paymentID : c'est cette clé que le reducer attend
		// (timePayment partait ici, et la ligne n'était pas mise à jour). Le montant recrédité au
		// 5000 est celui que rend domainModel : aucun total n'est plus envoyé.
		let data = {
			income_id : this.state.unlinkIncomeID,
			payments: [this.state.unlink.paymentID],
			paymentsID: [this.state.unlink.paymentID],
		}
		const issue = await this.props.unLinkPaymentsTo5000(data)
		// L'action rend son résultat. Le test portait sur le store, dont la valeur est
		// capturée au rendu et n'est donc pas rafraîchie par l'await : un échec
		// s'affichait comme un succès.
		if (issue && issue.ok === false) {
			toast.error(issue.error || "L'opération n'a pas abouti.")
			return
		}
		toast.info("Opération enregistrée avec succès")
		this.closeUnLink()
		this.handleSelectAllClick()
	}

	// Total à pointer = somme des montants saisis (une saisie invalide compte pour zéro).
	calcTotal = (list, linkAmounts = this.state.linkAmounts) => {
		return roundAmount(sumBy(list, (pay) => (parseFloat(linkAmounts[pay]) || 0)))
	}

	handleDownloadCSV = () => {
		const { PAYMENTS } = this.props;
		const { checkedPayments } = this.state;
		
		// Get payments to export: checked ones if any, otherwise all filtered
		let paymentsToExport;
		if (checkedPayments.length > 0) {
			paymentsToExport = checkedPayments.map(id => PAYMENTS[id]).filter(Boolean);
		} else {
			paymentsToExport = this.filterList();
		}
		
		// Build CSV with headers
		let csv = "Date Paiement,Id Transaction,Montant,Box ID,Nom,Type Paiement,Devise,Durée / Crédit,Code Envoyé,Status,Pointé,Montant pointé,Reste à pointer,Recettes 5000\n";
		
		paymentsToExport.forEach(payment => {
			csv += [
				new Date(payment.timePayment).toLocaleString('fr-FR'),
				payment.transactionId || '',
				payment.money || 0,
				payment.boxId || '',
				payment.userName || '',
				payment.methodPayment || '',
				payment.currency || '',
				`"${neutraliserFormuleCSV(effetDuPaiement(payment))}"`,
				payment.codeId || '',
				payment.status || payment.Status || '',
				incomeLinks(payment).length > 0 ? 'Oui' : 'Non',
				roundAmount(matched(payment)),
				remaining(payment),
				`"${incomeLinks(payment).map(link => `${link.income_id} (${roundAmount(link.amount)})`).join(' ; ')}"`
			].join(',') + '\n';
		});
		
		// Create and trigger download
		const link = document.createElement('a');
		link.href = "data:application/csv;charset=utf-8," + encodeURIComponent(csv);
		link.setAttribute('download', 'MyJouleBox-Payment-Data.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
 
  	render () {
		const { openLink, openUnLink, unlink, unlinkIncomeID, checkedPayments, sortDSC, openSingle, selected } = this.state;
		const { PAYMENTS } = this.props;
		console.log('[INFO], render fonction User Repayment', this.state);

		let payments = this.state.view === "Liste" ? this.createPaymentList() : {list: [], size: 0}
		return (
			<CardPage 
				title="Liste des paiements" 
				subtitle="Etat des paiements paygo"
				action={
					<IconButton color="secondary" title="Télécharger" onClick={this.handleDownloadCSV}>
						<CloudDownloadRounded />
					</IconButton>
				}
			>
				{openSingle && selected &&
					<PaymentSingle
						payment={selected}
						getIncomeInfo={this.props.getIncomeInfo}
						getPaymentSmsInfo={this.props.getPaymentSmsInfo}
						handleClose={()=> this.setState({ selected: {}, openSingle: false})}
					/>
				}
				<Card>
					<AppBar position="static">
						<Tabs
							value={this.state.view}
							onChange={(e, view) => this.setState({ view })}
							indicatorColor="secondary"
							variant="fullWidth"
							scrollButtons="auto"
						>
							<Tab value="Dashboard" label="Dashboard"/>
							<Tab value="Liste" label="Liste"/>
						</Tabs>
					</AppBar>
					
					<Box p={2}>
						{this.state.view === "Dashboard" ? (
							<RepayDashboard />
						) : (
							<Box>
								<Box p={1}>
									{/* <SearchBar list={ this.props.PAYMENTS } filterList={this.filterList}/> */}
									{PAYMENTS &&
										<FilterList 
											PAYMENTS={ this.props.PAYMENTS }
											handleChange={this.handleChange}
											handleSelect={this.handleSelect}
											handleChangeDate={this.handleChangeDate}
											{...this.state}
										/>
									}
								</Box>
								{size(checkedPayments) > 0 &&
									<Button variant="contained" color="primary" onClick={()=> this.setState({ openLink : true })}>
										Pointer {size(checkedPayments)} paiements
									</Button>
								}
								{openLink && size(checkedPayments) > 0 &&
									<LinkPaymentPopUp
										handleClose={()=> this.setState({ openLink : false, incomeID: "" })}
										rmPayment={this.rmPayment}
										handleChangeAmount={this.handleChangeAmount}
										amountsError={this.linkAmountsError()}
										handleSubmitLink={this.handleSubmitLink}
										handleChange={(e) => this.setState({[e.target.name]: e.target.value})}
										{...this.props}
										{...this.state}
									/>
								}
								{openUnLink && !isEmpty(unlink) && !unlinkIncomeID &&
									<Dialog
										block={true}
										title="Choisir la recette à dépointer"
										close={this.closeUnLink}
									>
										<List>
											{incomeLinks(unlink).map(link =>
												<ListItem button key={link.income_id} onClick={() => this.setState({ unlinkIncomeID: link.income_id })}>
													<ListItemText
														primary={`Recette ${link.income_id}`}
														secondary={formatMontantPaiement(link.amount, unlink.currency)}
													/>
												</ListItem>
											)}
										</List>
									</Dialog>
								}
								{openUnLink && !isEmpty(unlink) && !!unlinkIncomeID &&
									<DeleteDialog
										open={true}
										title={`le pointage sur la recette ${unlinkIncomeID}`}
										close={this.closeUnLink}
										handleSubmit={this.handleSubmitUnLink}
									/>
								}
								
								{this.props.PAYMENT_STATE.fetching ?
									<Box p={1} style={{ position: "relative", left:"46%"}}>
										<Spinner color="primary" />
									</Box>
								:
								<TableLayout>
									<TableHead>
										<TableRow>
											<TableCell padding="checkbox">
												<Checkbox
													indeterminate={size(checkedPayments) > 0 && size(checkedPayments) < payments.size}
													checked={payments.size > 0 && this.arrayEqual(payments.listAll, checkedPayments)}
													onChange={(e) => this.handleSelectAllClick(e, payments.listAll)}
													inputProps={{ 'aria-label': 'Selectionner tout' }}
												/>
											</TableCell>
											{/* <TableCell component="th" 
												onClick={() => this.setState({ sortDSC: !this.state.sortDSC})}
												>
												Date Paiement
											</TableCell> */}
											<TableCell
												sortDirection={sortDSC}
												component="th" 
											>
												<TableSortLabel
													active={true}
													direction={sortDSC ? 'desc' : 'asc'}
													onClick={() => this.setState({ sortDSC: !this.state.sortDSC})}
												>
													Date Paiement
												</TableSortLabel>
											</TableCell>
											<TableCell component="th">Id Transaction</TableCell>
											<TableCell component="th">Montant</TableCell>
											<TableCell component="th">Pointé</TableCell>
											<TableCell component="th">Pointage</TableCell>
											<TableCell component="th">Box ID</TableCell>
											<TableCell component="th">Nom</TableCell>
											<TableCell component="th">Type Paiement</TableCell>
											<TableCell component="th">Durée / Crédit</TableCell>
											<TableCell component="th">Code Envoyé</TableCell>
											<TableCell component="th">Infos</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{payments.list}
										{!this.props.PAYMENT_STATE.fetched &&
											<TableRow>
												<TableCell colSpan={12}><Spin noOverlay={true}/> </TableCell>
											</TableRow>									
										}
									</TableBody>
									
									<TableFooterPagination
										colSpan={12}
										count={payments.size} 
										onChangePage={this.onChangePage} 
										initialPage={this.state.currentPage} 
									/>
								</TableLayout>	
								}
								
							</Box>
						)}
					</Box>
				</Card>    
			</CardPage>
					
		);
  	}
};
function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
      PAYMENT_STATE: state.inventory.requestState.payments,
      PAYMENTS: state.payments,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
	  getPaymentsNEW,
	  linkPaymentsTo5000,
	  unLinkPaymentsTo5000,
	  getIncomeInfo,
	  getPaymentSmsInfo,
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps )(PaymentList);

